module.exports = __webpack_public_path__ + "src/img/platform.af000319.svg";